/**
 * Fill types
 */
export enum FillTypes {
    NO_FILL = "NO_FILL",
    SOLID_FILL = "SOLID_FILL",
    PICTURE_FILL = "PICTURE_FILL",
}
